// 错误
export const ARRANGE_ROUTE_FILE = 'ARRANGE_ROUTE_FILE';
// 更新
export const ARRANGE_ROUTE_UPDATE = 'ARRANGE_ROUTE_UPDATE';
